import { render, staticRenderFns } from "./index.vue?vue&type=template&id=47fe2fc4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fe2fc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\0.资料\\项目\\girdear_mall_center_web\\node_modules\\.store\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47fe2fc4')) {
      api.createRecord('47fe2fc4', component.options)
    } else {
      api.reload('47fe2fc4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=47fe2fc4&scoped=true", function () {
      api.rerender('47fe2fc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SelectSku/index.vue"
export default component.exports